export function scrollWindowToTop() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

export function scrollWindowToTopWithRetry(delays = [0, 100, 300]) {
  const timers = delays.map((delay) =>
    window.setTimeout(scrollWindowToTop, delay)
  );
  scrollWindowToTop();

  return () => {
    timers.forEach((timer) => window.clearTimeout(timer));
  };
}
